export const MODIFY_FILE_URL = 'MODIFY_FILE_URL';

export function modifyFileURL(fileURL){
    return{
        type: MODIFY_FILE_URL,
        mainState: {
            fileURL: fileURL
        }
    }
}